import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import db from "../../../../../db"
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import FormDialog from "../../../../../components/FormDialog/FormDialog"
import { toast } from 'react-toastify';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050,
    maxHeight: "440px"
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const DataTable = props => {
  const { className, ...rest } = props;
  const [data, setData] = useState([])
  const [op, setOp] = useState(false)
  const [opChange, setOpChange] = useState(false);
  const [code, setCode] = useState()
  const [department, setDepartment] = useState()
  const [pataskhanatu, setPastaskhanatu] = useState()
  const [id, setId] = useState()
  const fields = [
    {
      id: "code",
      label: "Կոդ",
      type: "text",
      value: code,
      func: setCode
    },
    {
      id: "storabajanum",
      label: "Ստորաբաժանում",
      type: "text",
      value: department,
      func: setDepartment
    },
    {
      id: "pastaskhanatu",
      label: "Պատասխանատու",
      type: "text",
      value: pataskhanatu,
      func: setPastaskhanatu
    }
  ]

  useEffect(() => {
    db.ref('InfoCenter/Departments').on('value', snap => {
      if (snap.val()) {
        setData(snap.val())
      } else {
        setData([])
      }
    })
  }, [])

  const handleDelete = (keyId) => {
    db.ref('InfoCenter/Departments/' + keyId).remove().then(() => {
      toast.success('Հեռացված է')
    })
  }
  const handleEdit = (keyId) => {
    setId(keyId)
    setCode(data[keyId].code)
    setDepartment(data[keyId].department)
    setPastaskhanatu(data[keyId].pataskhanatu)
    setOpChange(true)
  }
  const handleSaveEdit = () => {
    if (!code || !department || !pataskhanatu) {
      toast.error('Լրացրեք բոլոր դաշտերը')
      return
    }
    if (id) {
      db.ref('InfoCenter/Departments/' + id).set({
        code: code,
        department: department,
        pataskhanatu: pataskhanatu
      }).then(() => {
        toast.success('Փոփոխված է')
        setOpChange(false)
        setCode()
        setDepartment()
        setPastaskhanatu()
      })
    }
    setId()
  }

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Կոդ</TableCell>
                  <TableCell>Ստորաբաժանում</TableCell>
                  <TableCell>Պատասխանատու</TableCell>
                  <TableCell>Գործողություն</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(data).map(i => (
                  < TableRow
                    className={classes.tableRow}
                    hover
                    key={i}
                  >
                    <TableCell>
                      {data[i].code}
                    </TableCell>
                    <TableCell>
                      {data[i].department}
                    </TableCell>
                    <TableCell>
                      {data[i].pataskhanatu}
                    </TableCell>
                    <TableCell>
                      <IconButton color="primary" onClick={() => handleEdit(i)} style={{ "padding": "0" }}>
                        <EditIcon />
                      </IconButton>
                      <IconButton color="primary" size="small" onClick={() => handleDelete(i)} >
                        <DeleteForeverIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <FormDialog op={opChange} setOp={setOpChange} title="Փոփոխել ստորաբաժանումը" func={handleSaveEdit} fields={fields} />

    </Card>

  );
};

DataTable.propTypes = {
  className: PropTypes.string
};

export default DataTable;
